import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { subDays, addDays, subMonths, addMonths, subWeeks, format, isValid, differenceInMonths, isBefore } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';

import { diffWeeksDays } from '../commons/utils';

const InputsPage = ({ date, theoretic, term, diff, today, changeDate }) => {
    function updateDate(type, value) {
        if (!value) {
            changeDate({
                theoretic: null,
                date: null,
                term: null,
                diff: { weeks: 0, days: 0 },
                today: new Date(),
            });
            return;
        }
        let newDate;
        let newTheoretic;
        let newTerm;
        const newToday = type === 'today' ? value : today;
        const weeks = type === 'weeks' ? value : diff.weeks;
        const days = type === 'days' ? value : diff.days;
        switch (type) {
            case 'theoretic':
                newTheoretic = value;
                newDate = subDays(newTheoretic, 14);
                newTerm = addMonths(newTheoretic, 9);
                break;
            case 'term':
                newTerm = value;
                newTheoretic = subMonths(newTerm, 9);
                newDate = subDays(newTheoretic, 14);
                break;
            case 'date':
                newDate = value;
                newTheoretic = addDays(newDate, 14);
                newTerm = addMonths(newTheoretic, 9);
                break;
            case 'days':
            case 'weeks':
            case 'today':
                newDate = subDays(subWeeks(newToday, weeks), days);
                newTheoretic = addDays(newDate, 14);
                newTerm = addMonths(newTheoretic, 9);
                break;
            default:
                newDate = date;
                newTheoretic = theoretic;
                newTerm = term;
                break;
        }
        changeDate({
            date: newDate,
            theoretic: newTheoretic,
            term: newTerm,
            today: newToday,
            diff: diffWeeksDays(today, newDate),
        });
    }

    // useEffect(() => {
    //     if (!date) {
    //         updateDate('date', parseISO('2022-02-02'));
    //     }
    // });

    function renderDate(textDate, dateP, propName) {
        const curDate = dateP ? format(dateP, 'yyyy-LL-dd') : null;
        return (
            <div>
                <DatePicker
                    id={propName}
                    label={textDate}
                    value={curDate}
                    openTo="year"
                    views={['year', 'month', 'day']}
                    onChange={newValue => {
                        if (isValid(newValue)) {
                            const nbMonths = differenceInMonths(newValue, today);
                            if (Math.abs(nbMonths) < 10 && isBefore(newValue, today)) {
                                updateDate(propName, newValue);
                                return;
                            }
                        }
                        updateDate(propName, null);
                    }}
                    renderInput={params => <TextField size="small" {...params} />}
                />
            </div>
        );
    }

    const { weeks, days } = diff;
    // const weeksStr = weeks ? `${weeks} SA ` : '';
    // const daysStr = days ? `+ ${days} jour(s)` : '';
    return (
        <div className="main">
            {renderDate('Date des dernières règles', date, 'date')}
            {renderDate('Début théorique de grossesse', theoretic, 'theoretic')}
            {renderDate('Terme', term, 'term')}
            {renderDate('Date du calcul', today, 'today')}
            <span>Age gestationnel (depuis dernières règles)</span>
            <div className="age">
                <input
                    type="number"
                    id="weeks"
                    name="quantity"
                    min="0"
                    max="42"
                    value={weeks}
                    onChange={event => {
                        updateDate('weeks', event.target.value);
                    }}
                />
                <span> SA </span>
                <input
                    type="number"
                    id="days"
                    name="quantity"
                    min="0"
                    max="6"
                    value={days}
                    onChange={event => {
                        updateDate('days', event.target.value);
                    }}
                />
                <span> jour(s) </span>
            </div>
        </div>
    );
};

InputsPage.propTypes = {
    date: PropTypes.shape({}),
    theoretic: PropTypes.shape({}),
    term: PropTypes.shape({}),
    diff: PropTypes.shape({ weeks: PropTypes.number, days: PropTypes.number }),
    today: PropTypes.shape({}),
    changeDate: PropTypes.func,
};

InputsPage.defaultProps = {
    date: null,
    theoretic: null,
    term: null,
    diff: { weeks: 0, days: 0 },
    today: new Date(),
    changeDate: () => {},
};
export default InputsPage;
